import CommercialInvoice from "./CommercialInvoice";
import EssentialInvoice from "./EssentialInvoice";
import LegendExecutiveInvoice from "./LegendExecutiveInvoice";
import PrimeInvoice from "./PrimeInvoice";
import ProfessionalGSTInvoice from "./ProfessionalGSTInvoice";
import ServiceInvoice from "./ServiceInvoice";
import StructuredInvoice from "./StructuredInvoice";


export const TEMPLATE_MAP = {
  INVPRO: ProfessionalGSTInvoice,  
  INVESS: EssentialInvoice, 
  INVSTR: StructuredInvoice,
  INVCOM: CommercialInvoice,
  INVSEV: ServiceInvoice, 
  INVLEX: LegendExecutiveInvoice,
  INVPRM: PrimeInvoice,
};